import './switch.scss'
import React, { useState } from 'react'

export default function Switch({ active, leftLabel, rightLabel, onClick }) {
  const [isActive, setActive] = useState(active)

  const activate = () => {
    onClick(true)
    setActive(true)
  }

  const deActivate = () => {
    onClick(false)
    setActive(false)
  }

  return (
    <div className={`switch${isActive ? ' switch--active' : ''}`}>
      {leftLabel && (
        <label 
          className={`switch__leftLabel${!isActive ? ' switch__leftLabel--active' : ''}`} 
          onClick={deActivate}
        >
          {leftLabel}
        </label>
      )}
      {/* <div className="switch__toggle">
        <span></span>
      </div> */}
      {rightLabel && (
        <label 
          className={`switch__rightLabel${isActive ? ' switch__rightLabel--active' : ''}`} 
          onClick={activate}
        >
          {rightLabel}
        </label>
      )}
    </div>
  )
}
